export default {
    common: {
        save: 'ذخیره',
        cancel: 'انصراف',
        delete: 'حذف',
        edit: 'ویرایش',
        add: 'افزودن',
        confirm: 'تأیید',
        close: 'بستن',
        search: 'جستجو',
        loading: 'در حال بارگذاری...',
        noData: 'داده‌ای موجود نیست',
        yes: 'بله',
        no: 'خیر',
        actions: 'عملیات',
        logout: 'خروج',
        back: 'بازگشت',
        next: 'بعدی',
        submit: 'ثبت',
        name: 'نام',
        username: 'نام کاربری',
        phone: 'موبایل',
        email: 'ایمیل',
        company: 'شرکت',
        role: 'نقش',
        price: 'قیمت',
        status: 'وضعیت',
        date: 'تاریخ',
        notes: 'یادداشت',
        active: 'فعال',
        inactive: 'غیرفعال',
    },
    auth: {
        loginTitle: 'سامانه رزرو غذا',
        subtitle: 'رستوران آرشه',
        enterCredentials: 'نام کاربری یا شماره موبایل',
        password: 'رمز عبور',
        login: 'ورود',
        guestLogin: 'ورود مهمان با شماره موبایل (رزرو میز)',
        firstTimeTitle: 'تنظیم رمز عبور (ورود اول)',
        sessionCheck: 'در حال بررسی نشست...',
    },
    roles: {
        SUPER_ADMIN: 'سوپر ادمین',
        ADMIN: 'مدیر سیستم',
        SUPER_USER: 'کاربر ویژه',
        USER: 'کاربر',
        GUEST: 'مهمان',
    },
    nav: {
        overview: 'خلاصه',
        foods: 'غذاها',
        users: 'کاربران',
        companies: 'شرکت‌ها',
        menus: 'منوی روزانه',
        tables: 'میزها',
        reservations: 'رزرو میز',
        reports: 'گزارش‌ها',
        settings: 'تنظیمات',
    },
    food: {
        foodName: 'نام غذا',
        description: 'توضیحات',
        basePrice: 'قیمت پایه',
        category: 'دسته‌بندی',
        image: 'تصویر',
        newFood: 'افزودن غذای جدید',
        editFood: 'ویرایش غذا',
    },
    user: {
        newUser: 'افزودن کاربر جدید',
        editUser: 'ویرایش کاربر',
        resetPassword: 'بازنشانی رمز عبور',
        birthday: 'تاریخ تولد',
    },
    company: {
        newCompany: 'افزودن شرکت جدید',
        editCompany: 'ویرایش شرکت',
        discount: 'درصد تخفیف',
    },
    menu: {
        builder: 'سازنده منوی روزانه',
        pickDate: 'انتخاب تاریخ',
        pickFoods: 'انتخاب غذاها',
        deadline: 'مهلت ثبت سفارش',
        maxPerFood: 'حداکثر تعداد هر غذا',
        todayMenu: 'منوی امروز',
        noMenu: 'منویی برای این روز ثبت نشده است',
        ordersClose: 'مهلت سفارش',
        capacity: 'ظرفیت باقیمانده',
        soldOut: 'تکمیل',
        placeOrder: 'ثبت سفارش',
        cancel: 'لغو',
    },
    orders: {
        title: 'سفارش‌ها',
        myOrders: 'سفارش‌های من',
        recentOrders: 'سفارش‌های اخیر',
        noOrders: 'سفارشی ثبت نشده است',
        PENDING: 'در انتظار',
        CONFIRMED: 'تأیید شده',
        DELIVERED: 'تحویل داده شد',
        CANCELLED: 'لغو شده',
        cancelConfirm: 'سفارش لغو شود؟',
    },
    reports: {
        summary: 'گزارش کلی',
        totalOrders: 'تعداد کل سفارشات',
        totalRevenue: 'درآمد کل',
        popular: 'پرفروش‌ترین غذا',
        byCompany: 'درآمد به تفکیک شرکت',
        popularFoods: 'پرفروش‌ترین غذاها',
        downloadInvoice: 'دانلود فاکتور (PDF)',
    },
    birthdays: {
        today: 'تولد امروز',
        upcoming: 'تولدهای پیش‌رو',
        happyBirthday: 'تولدت مبارک، {{name}}!',
        daysAway: '{{days}} روز دیگر',
    },
    tables: {
        floorPlan: 'پلان رستوران',
        section: 'بخش',
        seats: 'صندلی',
        reserve: 'رزرو میز',
        reserveTime: 'زمان رزرو',
        partySize: 'تعداد نفرات',
        capacityExceeded: 'بیشتر از ظرفیت میز است',
        available: 'آزاد',
        reserved: 'رزرو شده',
        editLayout: 'ویرایش چیدمان',
        saveLayout: 'ذخیره چیدمان',
    },
    notifications: {
        enable: 'فعال‌سازی اعلان‌های مرورگر',
        enabled: 'اعلان‌ها فعال است',
        notSupported: 'مرورگر شما اعلان فشار را پشتیبانی نمی‌کند',
        denied: 'دسترسی اعلان رد شد',
        broadcastTitle: 'ارسال اعلان به همه',
    },
    settings: {
        theme: 'حالت نمایش',
        language: 'زبان',
        light: 'روشن',
        dark: 'تیره',
        system: 'سیستم',
    },
};
